<template>
    <div v-if="isVisible" class="fullscreen-overlay" @click="close">
        <img :src="imageUrl" class="fullscreen-image" />
    </div>
</template>

<script setup lang="ts">
import { onBeforeUnmount, onMounted, ref } from "vue"
import { offImageViewerOpen, onImageViewerOpen } from "./events"

const isVisible = ref(false)
const imageUrl = ref("")

const showImage = (url: string) => {
    imageUrl.value = url
    isVisible.value = true
}

function close() {
    isVisible.value = false
}

onMounted(() => {
    onImageViewerOpen(showImage)
})

onBeforeUnmount(() => {
    offImageViewerOpen(showImage)
})
</script>

<style scoped>
.fullscreen-overlay {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 90000;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
}

.fullscreen-image {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  padding: 1rem;
}
</style>
